<div class="user-list-container" appUserManual [userManualKey]="'user-admin-list'">
  <div class="user-filter">
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="filter" (keyup)="applyFilter()" type="text" name="filter" />
      @if (filter.length > 0) {
        <button matSuffix mat-icon-button aria-label="Clear" color="primary" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>
  @if (isLoading()) {
    <div class="spinner-container">
      <div class="spinner-wrapper">
        <app-spinner></app-spinner>
      </div>
    </div>
  } @else {
    <table mat-table appStickyTableHeader [maxHeight]="'calc(100vh - 280px)'" [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
      <!-- User avatar column: shows name, email, and SAP id from User DTO -->
      <ng-container matColumnDef="user">
        <th mat-header-cell mat-sort-header *matHeaderCellDef
          appColumnFilter="user.name"
          [filterDataSource]="dataSource">USER</th>
        <td mat-cell class="user" *matCellDef="let element">
          <app-user-avatar
            [user]="{
              name: element.user?.name,
              email: element.user?.email,
              sapId: element.user?.sapId,
              role: element.role,
            }"
          ></app-user-avatar>
        </td>
      </ng-container>

      <!-- Removed standalone email column; email is shown inside the avatar -->

      <ng-container matColumnDef="site">
        <th mat-header-cell *matHeaderCellDef
          appColumnFilter="site.siteNumber"
          [filterDataSource]="dataSource">Site</th>
        <td mat-cell class="site" *matCellDef="let element">{{ element.site?.siteNumber || 'N/A' }}</td>
      </ng-container>
      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef>Companies</th>
        <td mat-cell class="company" *matCellDef="let element">{{ displayCompanies(element.companies) }}</td>
      </ng-container>
      <ng-container matColumnDef="role">
        <th mat-header-cell mat-sort-header *matHeaderCellDef
          appColumnFilter="role"
          [filterDataSource]="dataSource">ROLE</th>
        <td mat-cell class="role" *matCellDef="let element">{{ element.role }}</td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef>Edit</th>
        <td mat-cell class="edit" *matCellDef="let element">
          <button class="edit-button" (click)="editProjectAccess(element)" mat-flat-button>
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</div>
